import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from '../environments/environment';
import { defineCustomElements } from '@npm-bbta/bbog-dig-dt-webcomponents-lib/loader';
import { CustomLogger } from '@npm-bbta/bbog-sg-frontend-logs-lib';

if (environment.production) {
    enableProdMode();
}

CustomLogger.isProduction = environment.production;

platformBrowserDynamic().bootstrapModule(AppModule)
    .catch(err => console.log(err));
defineCustomElements();



// WEBPACK FOOTER //
// ./src/main.ts